module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.f471825.woff";